<template>
    <v-row align="center">
        <FormCancellationReason :dialog.sync="dialog" :item="itemEdit" :initialize.sync="initTable" :handleModal="handleModal" v-if="dialog"/>
        <v-col cols="12" sm="12" md="12">
            <v-card class="elevation-4">
                <v-card-title>
                    <v-toolbar flat>
                        <v-btn small dark color="cyan darken-4" @click="nuevoMotivo">
                            <v-icon left>fas fa-plus-square</v-icon>Nuevo motivo
                        </v-btn>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-col cols="12" md="8" sm="4" class="d-flex justify-end">
                        <v-text-field v-model="search" append-icon="fas fa-search" label="Buscar motivo por nombre" single-inline hide-details @keydown.enter="searchCancellationReason">
                        </v-text-field>
                        <v-btn icon class="mt-4 ml-2">
                            <v-icon dense>fas fa-sync</v-icon>
                        </v-btn>
                        <Columns :headers.sync="headers"></Columns>
                    </v-col>
                </v-card-title>
                <v-data-table dense :headers="filteredHeaders" :items="cancellationReasons" class="elevation-1"
                :loading="loading" :options.sync="options"
                :footer-props="{ 'items-per-page-options': [ 25, 50, 100 ] }"
                :server-items-length="totalCancellationReason">
                    <template v-slot:[`item.actions`]="{ item }">
                        <v-menu bottom offset-x rounded="lg" transition="slide-y-transition" color="primary">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon v-bind="attrs" v-on="on" color="teal darken-1" class="white--text" small>
                                    <v-icon>fas fa-ellipsis-v</v-icon>
                                </v-btn>
                            </template>
                            <v-list dense>
                                <v-list-item disabled>
                                    <v-list-item-content>
                                        <v-list-item-subtitle>{{ item.name }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item @click.prevent="editarCancellationReason(item)">
                                    <v-list-item-title>
                                        <v-icon small class="mr-2">fas fa-edit</v-icon> Editar motivo
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item @click.prevent="eliminarCancellationReason(item)">
                                    <v-list-item-title class="red--text">
                                        <v-icon small class="mr-2 red--text">fas fa-trash-alt</v-icon> Borrar motivo
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </template>
                    <template v-slot:[`item.module`]="{ item }">
                        {{ moduleLabel(item.module) }}
                    </template>
                    <template v-slot:[`item.deleted`]="{ item }">
                        <v-chip :color="colorstatus(item.deleted)" label x-small dark
                            v-text="item.deleted ? 'Inactivo' : 'Activo'">
                        </v-chip>
                    </template>
                </v-data-table>
            </v-card>
        </v-col>
    </v-row>
</template>
<script>
import CancellationReasonDataService from '../../service/catalogo/cancellationReason/cancellationReasonDataService'
import FormCancellationReason from '@/components/cancellationReason/FormCancellationReason.vue';
import { getParamsPagination } from '@/utils/pagination';
import { moduleLabel } from '@/utils/cancellationModules';
import Columns from '@/components/shared/Columns.vue';
export default {
    name: "ListaCancellationReason",
    components: {
        FormCancellationReason, Columns
    },
    created() {
        this.initTable();
    },
    data() {
        return {
            cancellationReasons: [],
            options: {},
            totalCancellationReason: 0,
            search: "",
            loading: false,
            dialog: false,
            itemEdit: null,
            headers: [
                { text: "Acciones", value: "actions", sortable: false, groupable: false, show: true },
                { text: "ID", align: " d-none", sortable: false, value: "id", visible: false, groupable: false, show: false },
                { text: "Motivo", value: "name", sortable: false, groupable: false, show: true },
                { text: "Modulo", value: "module", sortable: false, groupable: false, show: true },
                { text: "Estatus (g)", value: "deleted", sortable: false, groupable: false, show: true },
            ]
        }
    },
    methods: {
        moduleLabel,
        searchCancellationReason() {
            this.options.page = 1;
            this.initTable(this.options);
        },
        async initTable( options = {}) {
            this.loading = true;
            const params = getParamsPagination({ options, search: this.search });
            await CancellationReasonDataService.getAllCancellationReason(params).then(response => {
                const { rows, totalElements } = response.data;
                this.cancellationReasons = rows;
                this.totalCancellationReason = totalElements;
            }).catch(error => {
                this.$swal.fire({ icon: 'error', title: 'Error al obtener los motivos de cancelacion', text: error, showConfirmButton: false, timer: 3000 });
            }).finally(() => {
                this.loading = false;
            })
        },
        nuevoMotivo() {
            this.itemEdit = null;
            this.dialog = true;
        },
        editarCancellationReason(item) {
            CancellationReasonDataService.show(item.id).then(response => {
                this.itemEdit = response.data;
                this.dialog = true;
            }).catch(err => {
                this.$swal.fire({ icon: 'error', title: 'Error al obtener el motivo', text: err.response?.data?.message, showConfirmButton: false, timer: 3000 });
            });
        },
        eliminarCancellationReason(item) {
            this.$swal({
                title: "Estas seguro?",
                text: "No se podra revertir la decision!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Si, eliminar!"
            }).then(result => {
                if (result.isConfirmed) {
                    CancellationReasonDataService.delete(item.id).then(rsp => {
                        if (rsp.status === 200) {
                            this.initTable();
                            this.$swal.fire({ icon: 'success', title: 'Motivo eliminado', text: 'El motivo se desactivo correctamente', showConfirmButton: false, timer: 1500 });
                        }
                        if (rsp.status === 400 || rsp.status === 404) {
                            this.$swal.fire({ icon: 'error', title: 'Error al eliminar el motivo', text: rsp.data.message, showConfirmButton: false, timer: 3000 });
                        }
                    }).catch(err => {
                        this.$swal.fire({ icon: 'error', title: 'Error!!', text: err.response?.data?.message, showConfirmButton: false, timer: 3000 });
                    });
                }
            });
        },
        colorstatus(deleted) { return deleted ? "error" : "success"; },
        handleModal() { this.dialog = !this.dialog; },

    },
    watch: {
        options: {
            handler( val, oldVal ) {
                if (val.page !== oldVal.page || val.itemsPerPage !== oldVal.itemsPerPage) {
                    this.initTable(val);
                }
            }, deep: true
        }
    },
    computed: {
        filteredHeaders() { return this.headers.filter(h => h.show); },
    }
}
</script>
